import { useTranslation } from 'react-i18next'

import { useGeneralErrors } from '@/hooks/useGeneralErrors'

export const GeneralErrorsBanner = () => {
  const { t } = useTranslation()
  const { generalErrors } = useGeneralErrors()

  if (!generalErrors) return null

  return (
    <div className="flex animate-fade-in flex-col gap-2 bg-gray-background p-6" data-testid="general-errors-banner">
      {generalErrors.map((error, index) => (
        <span key={index} className="font-bold text-error">
          {t(error.message)}
        </span>
      ))}
    </div>
  )
}
